import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

import { Paper } from 'componets/ui';
import {
	DateField,
	FormItem,
	PhoneField,
	SelectField,
	SubmitButton,
	TextField,
} from 'componets/form';

import { Rules } from 'utils/constants';

import { GENDER_OPTIONS, PersonalInformationProps } from './index';

import styles from '../../index.module.scss';
import {useAppSelector} from "../../../../hooks";
import {selectCountries} from "../../../../selectors";

export const PersonalInformationUser: FC<PersonalInformationProps> = ({
	maxDate,
	onChangeSelect,
	countriesOptions,
	country,
	loading,
}) => {
	const { t } = useTranslation();
	const countries = useAppSelector(selectCountries);
	const citizenshipList =  countries?.filter((item) => item.activeCitizenship).map((item) => {
		return {
			label: item.label,
			value: item.id,
		};
	});
	const formFields = [
		{
			name: 'firstName',
			component: <TextField label={t('firstNameText')} />,
			rules: [Rules.REQUIRED, Rules.MAX_LENGTH('firstName', 100)],
		},
		{
			name: 'lastName',
			component: <TextField label={t('lastNameText')} />,
			rules: [Rules.REQUIRED, Rules.MAX_LENGTH('lastName', 100)],
		},
		{
			name: 'citizenshipId',
			component: (
				<SelectField
					options={citizenshipList}
					placeholder={t('citizenshipText')}
					selectText={t('selectCitizenshipText')}
				/>
			),
			rules: [Rules.REQUIRED_SELECT],
		},
		{
			name: 'dateOfBirth',
			component: <DateField maxDate={maxDate} label={t('dateOfBirthText')} />,
			rules: [Rules.REQUIRED, Rules.INVALID_DATE(), Rules.MIN_AGE_18()],
		},
		{
			name: 'gender',
			component: (
				<SelectField
					options={GENDER_OPTIONS}
					placeholder={t('genderText')}
					selectText={t('selectGenderText')}
				/>
			),
			rules: [Rules.REQUIRED],
		},
		{
			name: 'countryId',
			component: (
				<SelectField
					selectText={t('selectCountryText')}
					options={countriesOptions}
					placeholder={t('countryResidenceText')}
					onChange={onChangeSelect}
					isFilter
				/>
			),
			rules: [Rules.REQUIRED],
		},
		{
			name: 'city',
			component: <TextField label={t('cityText')} />,
			rules: [Rules.REQUIRED, Rules.MAX_LENGTH('city', 50)],
		},
		{
			name: 'address',
			component: <TextField label={t('addressLabelText')} />,
			rules: [Rules.REQUIRED, Rules.MAX_LENGTH('address', 255)],
		},
		{
			name: 'zip',
			component: <TextField label={t('zipCodeText')} />,
			rules: [Rules.REQUIRED, Rules.MAX_LENGTH('zip', 20)],
		},
		{
			name: 'phone',
			component: <PhoneField country={country} label="phoneMobileText" />,
			rules: [Rules.REQUIRED, Rules.PHONE('phone')],
		},
		{
			name: 'referralCode',
			component: <TextField label={t('referralCodeText')} />,
			rules: [Rules.MAX_LENGTH('referralCode', 255)],
		},
	];

	return (
		<Paper styleName={styles.blockForm} top={<>2 / 2</>}>
			<Typography.Title level={4} className={styles.contactInfo}>
				{t('personalInformationFormText')}
			</Typography.Title>

			{formFields.map(({ name, component, rules }) => (
				<FormItem key={name} name={name} rules={rules}>
					{component}
				</FormItem>
			))}

			<SubmitButton text={t('continueText')} loading={loading} />
		</Paper>
	);
};
